import { render, staticRenderFns } from "./PresetEdit.vue?vue&type=template&id=470bb74d&scoped=true&"
import script from "./PresetEdit.vue?vue&type=script&lang=js&"
export * from "./PresetEdit.vue?vue&type=script&lang=js&"
import style0 from "./PresetEdit.vue?vue&type=style&index=0&id=470bb74d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "470bb74d",
  null
  
)

export default component.exports